import { useContext, useRef, useState } from "react";
import { CustomClaims, NotificationMSG, RMUser } from "../../types";
import { Alert, Button, Group, Modal, Title, } from "@mantine/core";
import { BsFiletypeCsv, BsMailbox, BsPlusCircle, } from "react-icons/bs";
import AddRmForm from "./AddRmForm";
import UpdateRMPasswordModal from "./UpdateRMPasswordModal";
import RmsInstantSearch, { RefreshButton, RefreshButtonRef } from "../../components/rms_instant_search";
import SendRmsWhatsappMessageForm from "../campaigns/SendRmsWhatsappMessageForm";
import { MyUserDataContext } from "../../contexts";
import { collection, DocumentData, getDocs, getFirestore, query, where } from "firebase/firestore";
import { IconAlertCircle } from "@tabler/icons-react";
import { CSVLink } from "react-csv";

const RMsListPage = () => {

    const [addRmModal, setAddRmModal] = useState<boolean>(false);
    const [sendWhatsappModal, setSendWhatsappModal] = useState<boolean>(false);
    const [updateRmModal, setUpdateRmModal] = useState<boolean>(false);
    const [rmUser, setRmUser] = useState<RMUser | null>();
    const [generatingCSV, setGeneratingCSV] = useState(false);
    const [data, setData] = useState<DocumentData[]>([]);
    const [downloadReady, setDownloadReady] = useState<boolean>(false);
    const [csvMsg, setCSVMsg] = useState<NotificationMSG>();

    const headers = [
        { label: "RM ID", key: "rm_id" },
        { label: "Name (EN)", key: "name_en" },
        { label: "Name (AR)", key: "name_ar" },
        { label: "Order Handler Email", key: "order_handler_email" },
        { label: "Email", key: "email" },
        { label: "Licensed", key: "certified" },
        { label: "Mobile", key: "mobile" },
        { label: "Segment", key: "segment" },
        { label: "Role", key: "role" },
        { label: "Active", key: "active" },

    ]
    const refreshRef = useRef<RefreshButtonRef | null>(null);

    const userContext = useContext(MyUserDataContext);
    let userClaims = userContext.firebaseTokenResult?.claims.customClaims as CustomClaims || {};
    const db = getFirestore();

    //Refresh the Typesense-backed list after a write. The RM doc change triggers an async cloud
    //function (onChangeRM) that re-indexes into Typesense. When that function is warm, indexing
    //finishes in <1s; but the FIRST edit after the portal has been idle hits a cold start that can
    //take several seconds to spin up + load secrets. The short retries cover the warm case, and the
    //later ones (up to ~18s) cover the one-time cold-start indexing latency so the first edit also
    //reflects without the user having to manually refresh or reopen the modal.
    const refreshListWithRetry = () => {
        [0, 1500, 3500, 6000, 9000, 13000, 18000].forEach((delay) => {
            setTimeout(() => refreshRef.current?.refresh(), delay);
        });
    };

    const handleSubmitGenerateCSV = async () => {
        setGeneratingCSV(true);
        let q = query(collection(db, "rms"))

        const rmsData: DocumentData[] = [];
        if (userClaims?.availableSegments) { q = query(q, where("segment", "in", userClaims.availableSegments)) }
        else if (userClaims?.segment) { q = query(q, where("segment", "==", userClaims.segment)) }
        else if (userClaims.admin) // for admin we get all rms
        {
            // get all rms/segments
            // q=q;
        }
        else {
            setGeneratingCSV(false);

            setCSVMsg({ type: "error", message: "Invalid user permissions" });
            return;
        }
        try {

            const querySnapshot = await getDocs(q);
            querySnapshot.docs.forEach((document) => {
                let d = document.data() as RMUser;
                rmsData.push(d);
            });
            setCSVMsg({ type: "success", message: "CSV Created Successfully" });
            setGeneratingCSV(false);
            setData(rmsData);
            setDownloadReady(true);
        }
        catch (error: any) {
            console.error("Error fetching documents: ", error);
            setCSVMsg({ type: "error", message: error?.message || "An error has occurred" });

        }

    }
    return (
        <div>
            <Group justify="space-between">
                <Title>KFH RMs</Title>

            </Group>

            <Modal
                size="xl"
                title=
                {<Title>
                    {rmUser ? "Update" : "Add"} KFH RM
                </Title>}
                opened={addRmModal}
                onClose={() => {
                    setAddRmModal(false)

                    setRmUser(null)
                }

                }
            >
                <AddRmForm rmUser={rmUser}
                    handleSubmit={() => {
                        setAddRmModal(false)
                        setRmUser(null)
                        refreshListWithRetry();
                    }
                    }

                />

            </Modal>
            <Modal

                title={

                    <Title
                        ms={30}
                        mt={30}
                        mb={20}
                        order={4}
                        ta="left">Send Rms Whatsapp message</Title>
                }
                size={"xl"}
                style={{ background: "red", width: "100%" }}
                // fullScreen
                opened={sendWhatsappModal}
                onClose={() => {
                    setSendWhatsappModal(false)

                }

                }
            >
                <SendRmsWhatsappMessageForm handleSubmit={() => setSendWhatsappModal(false)} />
            </Modal>
            {rmUser &&
                <>
                    <UpdateRMPasswordModal
                        open={updateRmModal}
                        user={rmUser}
                        onClose={() => {
                            setUpdateRmModal(false)
                            setRmUser(null)
                        }}
                        handleSubmit={() => {
                            refreshListWithRetry();
                        }}
                    />

                </>
            }


            {csvMsg && <Alert
                icon={<IconAlertCircle size={16} />}
                color={csvMsg.type == "success" ? "green" : "red"}
                title={csvMsg.type == "success" ? "Success" : "Failure"}
            >

                {csvMsg.message}
                <br />

                {downloadReady && <CSVLink data={data} headers={headers} onClick={() => setDownloadReady(false)}>
                    Download CSV
                </CSVLink>
                }

            </Alert>}
            <RmsInstantSearch
                setUpdateRmModal={setUpdateRmModal}
                setAddRmModal={setAddRmModal}
                setRmUser={setRmUser}
                indexName={import.meta.env.VITE_TYPESENSE_RMS_COLLECTION as string}
                topElements={
                    <>
                        <Button
                            mx={"sm"}
                            leftSection={<BsPlusCircle />}
                            onClick={() => setAddRmModal(true)}
                        >
                            Add RM
                        </Button>
                        {(userContext.msal || userClaims.kfh_oper) &&
                            <Button
                                loading={generatingCSV}

                                mx={"sm"}
                                leftSection={<BsFiletypeCsv />}
                                onClick={() => handleSubmitGenerateCSV()}
                            >
                                {`Generate CSV`}
                            </Button>
                        }
                        <Button
                            mx={"sm"}
                            leftSection={<BsMailbox />}
                            onClick={() => setSendWhatsappModal(true)}
                        >
                            Send Whatsapp
                        </Button>


                    </>
                }
                additionalChildren={<RefreshButton ref={refreshRef} />}
            />

        </div>
    )
}

export default RMsListPage